import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=1c49e46c&scoped=true"
import script from "./ClientsTable.vue?vue&type=script&lang=js"
export * from "./ClientsTable.vue?vue&type=script&lang=js"
import style0 from "./ClientsTable.vue?vue&type=style&index=0&id=1c49e46c&prod&lang=scss&scoped=true"
import style1 from "./ClientsTable.vue?vue&type=style&index=1&id=1c49e46c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c49e46c",
  null
  
)

export default component.exports